import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { RestClientModule } from '@common/services/rest-client/rest-client.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { StorageModule } from '@common/services/storage/storage.module';
import { SettingsModule } from '@common/services/settings/settings.module';
import { AuthGuard } from '@common/access-guard/auth-guard.class';
import { RoleGuard } from '@common/access-guard/role-guard.class';
import { TermsGuard } from '@common/access-guard/terms-guard.class';

import { AppInitializer } from './app.initializer';
import { AppService } from '@common/services/app.service';

import { AppSettings } from '@settings/app.settings';
import { RestClientSettings } from '@settings/rest-client.settings';
import { ConfirmedConcessionaireGuard } from '@common/access-guard/confirmed-concessionaire-guard.class';
import { ConfirmedTermsGuard } from '@common/access-guard/confirmed-terms-guard.class';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,

        SettingsModule.forRoot(AppSettings),
        StorageModule.forRoot(AppSettings.storageNS),
        RestClientModule.forRoot(RestClientSettings),
    ],
    providers: [
        AppService,
        AppInitializer,
        AuthGuard,
        RoleGuard,
        TermsGuard,
        ConfirmedConcessionaireGuard,
        ConfirmedTermsGuard,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
